<template>
    <div class="page-cabinet-verification-check" data-step="data-verification">
        <transition name="fade">
            <div class="page-cabinet-verification-check__loader"
                v-if="isLoading"
                >
                <div class="page-cabinet-verification-check__loader-container">
                    <ui-loader />
                </div>
            </div>
        </transition>

        <div class="page-cabinet-verification-check__subtitle" v-if="isJuridicalUser">
            Данные единоличного исполнительного органа организации:
        </div>
        <div class="page-cabinet-verification-check__list" v-bind:class="{ _full: !isJuridicalUser }">
            <ui-infolist
                v-bind:info="info"
            />
        </div>

        <template v-if="isJuridicalUser">
            <div class="page-cabinet-verification-check__subtitle" v-if="isJuridicalUser">
                Данные организации:
            </div>
            <div class="page-cabinet-verification-check__list">
                <ui-infolist
                    v-bind:info="organizationInfo"
                />
            </div>
        </template>

        <div v-if="isGetSms">
            <page-cabinet-verification-confirmation sms-only />
        </div>
        <div class="page-cabinet-verification-check__buttons" v-else>
            <div class="page-cabinet-verification-check__buttons-item"
                v-on:click="goToStart"
                >
                <ui-button
                    v-bind:disabled="isLoading"
                    theme="secondary-1"
                    size="lg"
                    >
                    Редактировать
                </ui-button>
            </div>
            <div class="page-cabinet-verification-check__buttons-item"
                v-on:click="submitHandler"
                >
                <ui-button
                    v-bind:disabled="isLoading"
                    theme="primary"
                    size="lg"
                    >
                    Все верно
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import utils from '~/utils';
export default {
    name: 'page-cabinet-verification-check',
    props: {
        isReApply: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        isGetSms: false,
    }),
    computed: {
        ...mapState('users', [
            'getUserProfileResult',
            'getUserProfileIsLoading',

            'getUserJuridicalInfoResult',
            'getUserJuridicalInfoIsLoading',

            'getUserPersonalInfoResult',
            'getUserPersonalInfoIsLoading',
        ]),
        isLoading() {
            return this.getUserProfileIsLoading ||
                this.getUserJuridicalInfoIsLoading ||
                this.getUserPersonalInfoIsLoading;
        },
        info() {
            const result = [];
            if (this.getUserProfileResult) {
                result.push({
                    title: 'ФИО',
                    value: this.getUserProfileResult.fullName,
                });
                result.push({
                    title: 'Телефон',
                    value: this.getUserProfileResult.phone,
                });
            }
            if (this.getUserPersonalInfoResult) {
                result.push({
                    title: 'Паспорт',
                    value: `${this.getUserPersonalInfoResult.passportSeries} ${this.getUserPersonalInfoResult.passportNumber}`,
                });
            }
            if (!this.isJuridicalUser && this.getUserJuridicalInfoResult) {
                result.push({
                    title: 'ИНН',
                    value: this.getUserJuridicalInfoResult.inn,
                });
            }
            if (!this.isJuridicalUser && this.getUserJuridicalInfoResult) {
                result.push({
                    title: 'СНИЛС',
                    value: this.getUserJuridicalInfoResult.snils,
                });
            }
            if (this.getUserProfileResult.legalType === 'I' && this.getUserJuridicalInfoResult) {
                result.push({
                    title: 'ОГРНИП',
                    value: this.getUserJuridicalInfoResult.ogrn,
                });
            }
            return result;
        },
        isJuridicalUser() {
            return this.getUserProfileResult && this.getUserProfileResult.legalType === 'J';
        },
        organizationInfo() {
            if (this.getUserJuridicalInfoResult) {
                return [
                    {
                        title: 'Наименование организации',
                        value: this.getUserJuridicalInfoResult.organizationName,
                    },
                    {
                        title: 'ИНН',
                        value: this.getUserJuridicalInfoResult.inn,
                    },
                    {
                        title: 'КПП',
                        value: this.getUserJuridicalInfoResult.kpp,
                    },
                    {
                        title: 'ОГРН',
                        value: this.getUserJuridicalInfoResult.ogrn,
                    },
                    {
                        title: 'Юридический адрес',
                        value: this.getUserJuridicalInfoResult.organizationAddress,
                    },
                    {
                        title: 'Фактический адрес',
                        value: this.getUserJuridicalInfoResult.legalAddress,
                    },
                    {
                        title: 'Почтовый адрес',
                        value: this.getUserJuridicalInfoResult.mailingAddress,
                    },
                ];
            }
            return null;
        },
    },
    methods: {
        submitHandler() {
            if (this.isLoading) {
                return;
            }
            if (this.isReApply) {
                this.isGetSms = true;
            } else {
                this.$emit('filled', 'check');
                this.$emit('submitted');
            }
        },
        goToStart() {
            this.$emit('update-step', 'profile');
        },
    },
    beforeMount() {
        this.$store.dispatch('users/getUserProfile');
        this.$store.dispatch('users/getUserPersonalInfo');
        this.$store.dispatch('users/getUserJuridicalInfo');
        utils.analytics.ym.dataVerificationStep();
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-verification-check {
    position: relative;
    &__loader {
        .transition-fade();

        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;

        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        background-color: fade(@color-gray-lightest, 50%);
        &-container {
            width: 100px;
            margin: auto;
        }
    }
    &__subtitle {
        .typography-heading();

        margin-bottom: 16px;
    }
    &__list {
        margin-bottom: 40px;
        &._full {
            min-height: 144px;
        }
    }
    &__buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: -12px;
        &-item {
            flex: 0 0 auto;
            padding: 12px;
        }
    }
    @media @media-md-down {
        &__buttons {
            flex-direction: column;
            align-items: stretch;
            &-item {
                width: 100%;
            }
        }
    }
}
</style>
